module.exports = __webpack_public_path__ + "img/choose1.2c4006cd.png";